import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { MaintenanceService } from "../../services/Maintenance/MaintenanceService";


interface ContextProps {
  isLoading: boolean
  handleMaintenance: () => Promise<boolean>;
}

const MaintenanceContext = createContext<ContextProps>({} as ContextProps);

export const MaintenanceProvider = ({ children }: { children: ReactNode }) => {
  const [isLoading, setIsLoading] = useState(true);
  const service = new MaintenanceService();

  const handleMaintenance = async () => {
    try {
      setIsLoading(true);
      const [_Response, _Error] = await service.getMaintenance();
      setIsLoading(false);

      if (!!_Error) {
        return false;
      }

      return _Response?.data?.is_under_maintenance;
    } catch (e: any) {
      setIsLoading(false);
      return false;
    }
  };

  return (
    <MaintenanceContext.Provider value={{ isLoading, handleMaintenance }}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export const useMaintenance = () => useContext(MaintenanceContext);
